var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testv__video__player__player__wrapper"},[_c('video',{staticClass:"video-js",attrs:{"id":"vid1","poster":_vm.video.pic,"autoplay":"","muted":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":this.video.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }